import { MISSIONS } from "../data/vocab";
import { useIsMobile } from "../hooks/useIsMobile";

export default function MissionComplete({ mission, xpEarned, onBack, onNext }) {
  const isMobile = useIsMobile();
  const isCustom = String(mission.id).startsWith("custom-");
  const idx = isCustom ? -2 : MISSIONS.findIndex(m => m.id === mission.id);
  const next = isCustom ? null : MISSIONS[idx + 1];

  return (
    <div style={{ maxWidth: 480, margin: "0 auto", animation: "popIn 0.4s ease" }}>
      <div style={{ background: "#fff", borderRadius: 24, border: "1px solid #ede8df", padding: isMobile ? "28px 18px" : "44px 40px", textAlign: "center" }}>
        <div style={{ display: "flex", justifyContent: "center", gap: 6, marginBottom: 18 }}>
          <div style={{ width: 8, height: 8, borderRadius: 2, background: "#f0a020" }} />
          <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#1a8f68" }} />
          <div style={{ width: 8, height: 8, borderRadius: 2, background: "#e24b4a", transform: "rotate(45deg)" }} />
          <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#3b82f6" }} />
          <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#f0a020" }} />
        </div>

        <div style={{ width: 80, height: 80, borderRadius: "50%", background: "linear-gradient(135deg,#1a8f68,#4ec99a)", margin: "0 auto 20px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <svg width="38" height="38" viewBox="0 0 38 38" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><circle cx="19" cy="19" r="14"/><path d="M12 19l5 5 9-9"/></svg>
        </div>

        <div style={{ fontSize: 26, fontWeight: 900, color: "#111", marginBottom: 6, letterSpacing: -0.6 }}>Session Complete!</div>
        <div style={{ fontSize: 13, color: "#b0a898", marginBottom: 28, lineHeight: 1.6 }}>
          Great work in <strong style={{ color: "#111" }}>{mission.title}</strong>!<br />
          {isCustom ? "Keep practicing to strengthen your memory." : (next ? `Keep going to unlock ${next.title}.` : "You've reached Master Level!")}
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 24 }}>
          <div style={{ background: "#fff5e0", borderRadius: 13, padding: 14 }}>
            <div style={{ fontSize: 22, fontWeight: 900, color: "#e8900a" }}>+{xpEarned}</div>
            <div style={{ fontSize: 11, color: "#b0a898", marginTop: 2 }}>XP earned</div>
          </div>
          <div style={{ background: "#e8f7f1", borderRadius: 13, padding: 14 }}>
            <div style={{ fontSize: 22, fontWeight: 900, color: "#1a8f68" }}>10</div>
            <div style={{ fontSize: 11, color: "#b0a898", marginTop: 2 }}>Words reviewed</div>
          </div>
        </div>

        {next && (
          <button onClick={() => onNext(next)} style={{
            width: "100%", padding: "15px", background: "#1a8f68", color: "#fff", border: "none",
            borderRadius: 13, fontSize: 15, fontWeight: 800, cursor: "pointer", fontFamily: "inherit",
            display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 10,
          }}>
            Next Session
            <svg width="14" height="14" viewBox="0 0 15 15" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round"><path d="M3 7.5h9M8.5 3.5l4 4-4 4"/></svg>
          </button>
        )}
        <button onClick={onBack} style={{
          width: "100%", padding: "13px", background: "#faf8f5", color: "#555", border: "1.5px solid #e8e2d8",
          borderRadius: 13, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit",
        }}>{isCustom ? "Back to Lexicon" : "Back to Mission Map"}</button>
      </div>
    </div>
  );
}
